import React, {useState, useEffect} from 'react'
import { IoCopyOutline } from 'react-icons/io5'
import { RiFolderZipLine } from 'react-icons/ri'
import {useAuth} from '../../index'
import axios from 'axios'
import postscribe from 'postscribe'
// import IndexedJSONTS from '../python/database_json/client/DatabaseJSON'
import BookInterview1JS from './BookInterviewSimple.js'
import BookInterview2JS from './BookInterviewCalendar.js'
import BookDemoDrive1JS from './BookDemoDriveSimple.js'
import BookDemoDrive2JS from './BookDemoDriveCalendar.js'
import BookHotelRoom1JS from './BookHotelRoomSimple.js'
import BookHotelRoom2JS from './BookHotelRoomCalendar.js'
import BookRentRoom1JS from './BookRentRoomSimple.js'
import BookRentRoom2JS from './BookRentRoomCalendar.js'
import LlmGenerateImg from './GenAIImg.js'
import LlmABConversations from './LlmABConversations.js'
import LlmSpeechText from './LlmSpeechText.js'
import LlmStockNews from './LlmStockNews.js'
import LlmSummarize from './LlmSummarize.js'
import LlmTranslator from './LlmTranslator.js'
import LlmAuthor from './LlmAuthor.js'
import LlmCopilot from './LlmCopilot.js'
import LlmContext from './LlmContext.js'
import LlmRag1 from './LlmRag1.js'
import LlmRag2 from './LlmRag2.js'
import LlmGoogleSearch from './LlmGoogleSearch.js'
import LlmChatbotFrame from './LlmChatbotFrame.js'
import { MdCode, MdCodeOff } from 'react-icons/md'
import { TbBrowser, TbFileCode2 } from 'react-icons/tb'
import { LiaShoppingBagSolid } from 'react-icons/lia'
import StickerImg from '../../images/sticker.jpg'
import productList from '../../util/products.json'
import DbJson from './../node/db_json'
import DbJsonGen from './../node/db_json_gen'
import DbCSV from './../node/db_csv'
import DbPg from '../node/db_pg'
import DbMysql from './../node/db_mysql'
import DbCloudMg from '../node/db_cloud_mg'
import DbCloudAwsDynamo from '../node/db_cloud_aws_dynamo'
import DbCloudMsAzure from '../node/db_cloud_ms_azure'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function BasicPage() {
  const {shoppingCart1, shoppingCart2, auth2FA1, user2, logout} = useAuth()
  const [userInfo, setUserInfo] = useState(null)
  const [msg, setMsg] = useState('')
  const [loadCode, setLoadCode]=useState(false)
  const [shoppingCart3, setShoppingCart3] = useState([])
  const [displayShowAllDemo, setDisplayShowAllDemo] = useState(false)
  const [displayShowAllCode, setDisplayShowAllCode] = useState(false)
  const [code, setCode] = useState([{name:'code1',code:''},{name:'code2',code:''},{name:'code3',code:''},{name:'code4',code:''}])
  const [property, setProperty] = useState([{id:'001',demo:false,code:false,copy:'',tab:'nodejs'},{id:'002',demo:false,code:false,copy:'',tab:'nodejs'},{id:'003',demo:false,code:false,copy:'',tab:'nodejs'},{id:'004',demo:false,code:false,copy:'',tab:'nodejs'},{id:'005',demo:false,code:false,copy:'',tab:'nodejs'},{id:'006',demo:false,code:false,copy:'',tab:'nodejs'},{id:'007',demo:false,code:false,copy:'',tab:'nodejs'},{id:'008',demo:false,code:false,copy:'',tab:'nodejs'},{id:'009',demo:false,code:false,copy:'',tab:'nodejs'},{id:'010',demo:false,code:false,copy:'',tab:'nodejs'},{id:'011',demo:false,code:false,copy:'',tab:'nodejs'},{id:'012',demo:false,code:false,copy:'',tab:'nodejs'},{id:'013',demo:false,code:false,copy:'',tab:'nodejs'},{id:'014',demo:false,code:false,copy:'',tab:'nodejs'},{id:'015',demo:false,code:false,copy:'',tab:'nodejs'}])
  useEffect(() => {
    //if user is already logged in
    if(userInfo==null&&user2){
      const handleSubmit = async (e) => {
        const { data: res } = await axios.post(`${APIURL}/account-info`, {token:window.localStorage.getItem('token')})
        if(res.msg==='user info ok'){    
          setUserInfo(res.user)
        }else{
          setMsg(res.msg)
          setTimeout(() => {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            logout()
          }, 3000)
        }
      }
      setTimeout(handleSubmit, 1)
    }
    if(!loadCode){
      setTimeout(getCode, 2)
      setLoadCode(true)
    }
    setShoppingCart3(shoppingCart2)
  },[shoppingCart2])
  const onClick2AddCodeProduct=(x1)=>{
    if (shoppingCart2!=[]) {
      const existedItem = shoppingCart2.find((x)=>x.id==x1.id)
      if(!existedItem){
        setShoppingCart3([...shoppingCart2, {"id":x1.id,"product_name":x1.product_name,"unit":1,"price":x1.price,"img":x1.img}])
        shoppingCart1([...shoppingCart2, {"id":x1.id,"product_name":x1.product_name,"unit":1,"price":x1.price,"img":x1.img}])
      }
    }else {
      console.log('item is already in cart')
    }
  }
  const getCode = async() =>{
    let code_request = []
    let checklist=['store data']
    if(user2){
      for(let i=0;i<checklist.length;i++){if(user2.unlocked_code.includes(checklist[i])){code_request.push(checklist[i])}}
    }
    const { data: res } = await axios.post(`${APIURL}/get-code`,{'code_request':code_request})
    for(let i=0;i<res.code_data.length;i++){    
      if(Object.keys(res.code_data[i])[0]=='store data'){
        //find item first from key
        const x1=Object.values(res.code_data[i])[0]
        const tempData2=[...code]
        tempData2[0].code=x1
        setCode(tempData2)
        const nodeItems=x1.filter(x2=>x2.name=='nodejs')[0]
        const i1=property.indexOf(property.filter((x2)=>x2.id=='001')[0])
        const i2=property.indexOf(property.filter((x2)=>x2.id=='002')[0])
        const i3=property.indexOf(property.filter((x2)=>x2.id=='003')[0])
        const i4=property.indexOf(property.filter((x2)=>x2.id=='004')[0])
        const i5=property.indexOf(property.filter((x2)=>x2.id=='005')[0])
        const i6=property.indexOf(property.filter((x2)=>x2.id=='006')[0])
        const tempData=[...property]
        tempData[i1].copy=nodeItems.valiation[0].code
        tempData[i2].copy=nodeItems.valiation[1].code
        tempData[i3].copy=nodeItems.valiation[2].code
        tempData[i4].copy=nodeItems.valiation[3].code
        tempData[i5].copy=nodeItems.valiation[4].code
        tempData[i6].copy=nodeItems.valiation[5].code
        setProperty(tempData)
      }
    //'json','json gen','csv','pg','mysql','cloud - mg','cloud - dynamo','cloud - lambda',
    // else if (Object.keys(res.code_data[i])[0]=='llm rag & tools'){
    //     const x1= Object.values(res.code_data[i])[0]
    //     setCode2(x1)
    //     const pyItems = x1.filter(x2=>x2.name=='py')[0]
    //     setCopy7(pyItems.valiation[0].code)
    //     setCopy8(pyItems.valiation[1].code)
    //     setCopy9(pyItems.valiation[2].code)
    //     setCopy10(pyItems.valiation[3].code)
    //     setCopy11(pyItems.valiation[4].code)
    // }
    }
  }
  const onClick2Tab2= (x1, y1, z1, w1) =>{
    //x1:01 y1:code z1:tsx w1:display toggledown
    const item=property.filter((x2) => x2.id == x1)[0]
    const i=property.indexOf(item)
    const tempData=[...property]
    tempData[i].tab=z1
    setProperty(tempData)
    //output code at copy icon
    y1.filter(x2=>{if(x2.name==z1){x2.valiation.filter(x3=>{
      if(x3.name==w1){
        const item=property.filter((x2)=>x2.id==x1)[0]
        const i=property.indexOf(item)
        const tempData=[...property]
        tempData[i].copy=x3.code
        setProperty(tempData)
      }
    })
    }})
  }
  const onClick2Download = async(x) =>{
    const code_request = `${x}.zip`
    const { data: res } = await axios.post(`${APIURL}/get-node-python-code-zip`,{'code_request':code_request})
    const link = document.createElement('a')
    link.href = `data:application/zip;base64,${res['code_zip_data']}`
    link.download =`${x}.zip`
    link.click()
  }
  const onClick2Copy=(x)=>{navigator.clipboard.writeText(x)}
  const onClick2DisplayDemo=(x)=>{
    const item=property.filter((x1) => x1.id == x)[0]
    const i=property.indexOf(item)
    const tempData=[...property]
    tempData[i].demo=!item.demo
    console.log('demo clicked',i, item)
    setProperty(tempData)
  }
  const onClick2DisplayCode=(x)=>{
    const filteredData = property.filter((x1) => x1.id == x)[0]
    const indexOfRecord = property.indexOf(filteredData)
    const tempData = [...property]
    tempData[indexOfRecord].code = !filteredData.code
    setProperty(tempData)
  }
  const onClick2ShowAllDemo=()=>{
    setDisplayShowAllDemo(!displayShowAllDemo)
    const tempData = [...property]
    for(let i=0;i<property.length;i++){
      tempData[i].demo=!displayShowAllDemo
    }
    setProperty(tempData)
  }
  const onClick2ShowAllCode =()=>{
    setDisplayShowAllCode(!displayShowAllCode)
    const tempData = [...property]
    for(let i=0;i<property.length;i++){
      tempData[i].code=!displayShowAllCode
    }
    setProperty(tempData)
    setDisplayShowAllCode(!displayShowAllCode)
  }
  return(
  <>
  <div className='text-left ml-[4px] mr-[4px] sm:mt-8 sm:m-auto w-auto md:w-[580px] lg:w-[780px]'>

  <div className='text-[9px]'>
  </div><div className='flex justify-between mb-4'><h2 className='text-lg structure__main__subttl'>Basic Functions</h2><div className='mt-auto'><button className={`color-[#414c75] bitter text-xs cursor-default rounded-md pl-2 pr-2 ${!displayShowAllDemo?'text-gray-300 hover:text-gray-400':'text-gray-800'}`} onClick={onClick2ShowAllDemo}>all demo</button><button className={`color-[#414c75] bitter text-xs cursor-default rounded-md pl-2 pr-2 ${!displayShowAllCode?'text-gray-300 hover:text-gray-400':'text-gray-800'}`} onClick={onClick2ShowAllCode}>all code</button></div></div> 

  {/* <IndexedJSONTS/> */}<div className='mb-2 bitter'><b>Store Data</b></div>
  <div className='flex mb-1'>{userInfo!=null?<>{userInfo.unlocked_code.includes('store data')?<>{code[0].code==''?<div className='text-[9px] mt-auto ml-2'>Please login again to load purchased code.</div>:<div className='text-gray-800 cursor-default text-[9px] rounded-sm mt-auto mb-auto bitter font-bold'>Store Data Code ${productList.code_products.map((x)=><>{x.product_name=='store data'?<>{x.price}+Tax <span className='sans-serif font-normal bg-gray-200 pl-[4px] pr-[4px]'>purchased</span></>:''}</>)}</div>}</>:<>{productList.code_products.map((x)=><>{x.product_name=='store data'?<><div className='text-[9px] bitter font-bold mt-auto mb-auto'>Sereverless Store Data Code${x.price}+Tax</div>{x.contents.map(x1=><span className='text-[8px] cursor-default ml-[1px] mt-auto mb-auto bg-gray-100 pl-1 pr-1'>{x1}</span>)}<button className='purchase-item-btn bitter bg-[#414c75] text-white text-[9px] h-[18px] pt-[2px] pl-[6px] pr-[6px] mt-auto mb-auto flex ml-1' onClick={()=>onClick2AddCodeProduct(x)} disabled={shoppingCart3.map(x=>x.product_name).includes('store data')?true:false}>+ Add to Cart</button></>:''}</>
  )}</>}</>:<div className='ml-[2px] mt-auto mb-auto text-[9px] w-fit'>You need to login to see or purchase the code</div>}</div>
  <div className='text-xs bitter'><b>local file json</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('001')}><p className={`text-[9px] h-fit cursor-default ${!property[0].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('001')}><MdCode className={`${!property[0].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>
  {property[0].demo?<DbJson/>:''}{property[0].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='json'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('001',code[0].code, x.name, 'json')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[0].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_json')} /><IoCopyOutline onClick={()=>onClick2Copy(property[0].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[0].tab?<>{x1.valiation.map(x2=><>{x2.name=='json'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}
  
  <div className='text-xs mt-2 bitter'><b>local file json gen</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('002')}><p className={`text-[9px] h-fit cursor-default ${!property[1].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('002')}><MdCode className={`${!property[1].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>
  {property[1].demo?<DbJsonGen/>:''}{property[1].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='json gen'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('002',code[0].code, x.name, 'json gen')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[1].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('basic_db_json_gen')} /><IoCopyOutline onClick={()=>onClick2Copy(property[1].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[1].tab?<>{x1.valiation.map(x2=><>{x2.name=='json gen'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}

  <div className='text-xs mt-2 bitter'><b>local file csv</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('003')}><p className={`text-[9px] h-fit cursor-default ${!property[2].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('003')}><MdCode className={`${!property[2].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>
  {property[2].demo?<DbCSV/>:''}{property[2].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='csv'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('003',code[0].code, x.name, 'csv')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[2].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_csv')} /><IoCopyOutline onClick={()=>onClick2Copy(property[2].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[2].tab?<>{x1.valiation.map(x2=><>{x2.name=='csv'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}

  <div className='text-xs mt-2 bitter'><b>database postgres</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('004')}><p className={`text-[9px] h-fit cursor-default ${!property[3].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('004')}><MdCode className={`${!property[3].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>
  {property[3].demo?<DbPg/>:''}{property[3].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='pg'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('004',code[0].code, x.name, 'pg')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[3].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_pg')} /><IoCopyOutline onClick={()=>onClick2Copy(property[3].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[3].tab?<>{x1.valiation.map(x2=><>{x2.name=='pg'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}

  <div className='text-xs mt-2 bitter'><b>database mysql</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('005')}><p className={`text-[9px] h-fit cursor-default ${!property[4].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('005')}><MdCode className={`${!property[4].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>{property[4].demo?<DbMysql/>:''}
  {property[4].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='mysql'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('005',code[0].code, x.name, 'mysql')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[4].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_mysql')} /><IoCopyOutline onClick={()=>onClick2Copy(property[4].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[4].tab?<>{x1.valiation.map(x2=><>{x2.name=='mysql'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}
  
  <div className='text-xs mt-2 bitter'><b>cloud database mongodb</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('006')}><p className={`text-[9px] h-fit cursor-default ${!property[5].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('006')}><MdCode className={`${!property[5].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>
  {property[5].demo?<DbCloudMg/>:''}{property[5].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='cloud - mg'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('006',code[0].code, x.name, 'cloud - mg')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[5].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_cloud_mg')} /><IoCopyOutline onClick={()=>onClick2Copy(property[5].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[5].tab?<>{x1.valiation.map(x2=><>{x2.name=='cloud - mg'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}

  <div className='text-xs mt-2 bitter'><b>cloud database amazon aws dynamo</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('007')}><p className={`text-[9px] h-fit cursor-default ${!property[6].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('007')}><MdCode className={`${!property[6].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>{property[6].demo?<DbCloudAwsDynamo/>:''}{property[6].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='cloud - dynamo'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('007',code[0].code, x.name, 'cloud - dynamo')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[6].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_cloud_mg')} /><IoCopyOutline onClick={()=>onClick2Copy(property[6].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[6].tab?<>{x1.valiation.map(x2=><>{x2.name=='cloud - dynamo'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}

  <div className='text-xs mt-2 bitter'><b>cloud database microsoft azure</b></div>
  <div className='flex'>
  <div className={`text-xs cursor-default w-fit`} onClick={()=>onClick2DisplayDemo('008')}><p className={`text-[9px] h-fit cursor-default ${!property[7].demo?'text-gray-400 hover:text-gray-600':'text-gray-800'}`}>demo</p></div>
  <div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>onClick2DisplayCode('008')}><MdCode className={`${!property[7].code?'text-gray-300 hover:text-gray-400':'text-gray-800'}`}/></div>
  </div>{property[7].demo?<DbCloudMsAzure/>:''}{property[7].code?<><div className='w-full md:w-[500px]'>{code[0].code==''?<div className='cursor-default mt-4 ml-8 mb-4 text-[9px]'>Purchase code to display</div>:<><div className='flex justify-between'><div className='text-[8px] mt-auto'>{code[0].code.map(x=><>{x.valiation.map(x2=><>{x2.name=='cloud - lambda'?<>{x2.code.length>1?<span onClick={()=>onClick2Tab2('008',code[0].code, x.name, 'cloud - lambda')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${property[7].tab==x.name ?'font-bold':''} `}>{x.name}</span>:''}</>:''}</>)}</>)}</div><div className='flex'><RiFolderZipLine className='text-xs text-gray-900 hover:bg-gray-200 hover:cursor-default mt-auto mb-auto' onClick={()=>onClick2Download('db_cloud_mg')} /><IoCopyOutline onClick={()=>onClick2Copy(property[7].copy)} className='text-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/></div></div><div className='w-full mb-1'><pre className='primary-code-container'>{code[0].code.map(x1=><>{x1.name==property[7].tab?<>{x1.valiation.map(x2=><>{x2.name=='cloud - lambda'?<>{x2.code}</>:''}</>)}</>:''}</>)}</pre></div></>}</div></>:''}

 
    <hr className='mt-4 mb-4'/>
    <div className='mb-2'><b>Login</b></div>
    <div className='text-xs mt-2 bitter'><b>simple login</b></div>
    <div className='text-xs mt-2 bitter'><b>simple login + admin</b></div>
    <div className='text-xs mt-2 bitter'><b>jwt login</b></div>
    <div className='text-xs mt-2 bitter'><b>OTP <span className='text-[8px]'>one time passcode</span></b></div>
    <div className='text-xs mt-2 bitter'><b>2FA <span className='text-[8px]'>two factor authontication</span></b></div>
    <hr className='mt-4 mb-4'/>
    <div className='text-xs mt-2 bitter'><b>admin role</b></div>
    <div className='text-[9px]'>count visitor per day<br/>
    click per day<br/>
    clicked place and purchased price*<br/>
    *add id at localstorage and count it when user purchased it </div>
    <br/>
    <hr className='mt-4 mb-4'/> 
    <div className='mb-2'><b>Crud</b></div>
    <div className='mb-2'><b>Reservation</b></div>
    <div className='text-xs mt-2 bitter'><b>Interview Simple</b></div>
    <BookInterview1JS/>
    <div className='text-xs mt-2 bitter'><b>Interview Calendar</b></div>
    <BookInterview2JS/>
    <div className='text-xs mt-2 bitter'><b>Demo Drive Simple</b></div>
    <BookDemoDrive1JS/>
    <div className='text-xs mt-2 bitter'><b>Demo Drive Calendar</b></div>
    <BookDemoDrive2JS/>
    <div className='text-xs mt-2 bitter'><b>Hotel Reservation Simple</b></div>
    <BookHotelRoom1JS/>
    <div className='text-xs mt-2 bitter'><b>Hotel Reservation Calendar</b></div>
    <BookHotelRoom2JS/>
    <div className='text-xs mt-2 bitter'><b>Contract Rent Room Simple</b></div>
    <BookRentRoom1JS/>
    <div className='text-xs mt-2 bitter'><b>Contract Rent Room Calendar</b></div>
    <BookRentRoom2JS/>
    <div className='text-xs mt-2'>
      set calendar visible<br/>
      Notify jsonfile via mail everyday<br/>
      Notify url to the customer<br/>
    </div> 
</div>






    {/* <hr className='mt-4 mb-4'/>
    <div className='mb-2'><b>LLM Agents</b></div>
    <div className='text-xs mt-2 bitter'><b>[remove later]JSON Simple Chatbot</b></div>
    <div className='text-xs mt-2 bitter'><b>[remove later]Chatbot Frame</b></div>
    <div className='text-xs mt-2 bitter'><b>Chatbot LLM vol.1</b></div>
    <div className='text-xs mt-2 bitter'><b>Booking Agent</b></div> */}
    {/* 
    <b>Customise your own chatbot</b><br/>
    [1] Purchase Frame of chatbot<br/>
    [2] Purchase Agent to customise chatbot<br/>
    [3] Synstem auto generate item and create zip file for you.<br/>
   
    Promotion Chatbot<br/>
    Booking Manager Chatbot (vehicle)<br/>
    Reservation Manager Chatbot<br/>
    EC Chatbot<br/>
    1. Open question<br/>
        Categorised by 6 categories.<br/>
        categories = ['product','event','demo drive','purchase','after service','none of them above']<br/>
        categories_1 = ['KONA','The new IONIQ 5','IONIQ 5 N','NEXO', 'others']<br/>
        categories_1_1 = ['distance','mode details','grade','price','others']<br/>
        categories_1_2 = ['distance','mode details','grade','price','others']<br/>
        categories_1_3 = ['distance','mode details','grade','price','others']<br/>
        categories_1_4 = ['distance','mode details','grade','price','others']<br/>
        categories_1_5 = 'We are only selling KONA, The new IONIQ 5, IONIQ 5 N and NEXO in Japan.<br/>
        categories_1 = 'No upcoming event.'<br/>
        categories_3 = ['place', 'appointment', 'other']<br/>
        categories_4 = ['place', 'appointment', 'other']<br/>
        I want to know about ...

        Maximum driven distance is depends on the grade.
        ・Casual：approx456km
        ・Voyage：approx625km
        ・Lounge：approx541km
        ・LoungeTwo-tone：approx541km
        ・N Line : approx541Km

        Ask to operator
        Back to previous page
        Go back to top']<br/>
    2.</div> */}

    
    {/*  <LlmChatbotFrame/><div className='text-left m-auto mt-8 w-full md:w-[580px] lg:w-[780px]'>
    <hr className='mt-4 mb-4'/>
    <div className='mb-2'><b>OCR</b></div>
    <hr className='mt-4 mb-4'/>
    <h2 className='mb-4 text-lg structure__main__subttl'>NPL</h2>
    <hr className='mt-4 mb-4'/>
    <h2 className='mb-4 text-lg structure__main__subttl'>MLP</h2>
    <hr className='mt-4 mb-4'/>
    <h2 className='mb-4 text-lg structure__main__subttl'>ML</h2>
    </div> */}
    {/* <b>Image Generation</b>
    <div className='flex'><div className='text-xs hover:font-bold cursor-default w-fit' onClick={()=>setDisplayDemo5(!displayDemo5)}>{displayDemo5?<TbBrowser/>:'demo'}</div>
    {userInfo!=null?<>{userInfo.unlocked_code.includes('crud multi')?<>
    {code1==''?<>'please load purchased code'</>:<div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>setDisplayCode5(!displayCode5)}>{displayCode5?<MdCode/>:<MdCodeOff/>}</div>}</>:<>
    {productList.code_products.map((x)=><>{x.product_name=='crud multi'?<>
    <button className='purchase-item-btn ml-1' onClick={()=>onClick2AddCodeProduct(x)} 
    disabled={shoppingCart3.map(x=>x.product_name).includes('crud multi')?true:false}
    >Buy Crud Multi Code ${x.price}</button> 
    {x.contents.map(x1=><span className={`text-[8px] cursor-default ml-1 mt-auto mb-auto rounded-md pl-1 pr-1 ${x1=='js'?'bg-yellow-400':''} ${x1=='ts'?'bg-blue-400':''} ${x1=='scss'?'bg-pink-500':''}`}>{x1}</span>)}
    </>:''}</>)}</>}</>:''}
    </div>
    {displayDemo5?<LlmGenerateImg/>:''}
    {displayCode5?<>
    <div className='w-full md:w-[500px]'>
    <div className='flex justify-between'>
    <div className='text-[8px] mt-auto'>
    {code1.map(x=><span onClick={()=>onClick2Tab2(code1, x.name, 'crud multi')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${code5Tab==x.name?'font-bold':''}`}>{x.name}</span>)}
    </div>
    <div className='flex'><IoCopyOutline onClick={()=>onClick2Copy(copy5)} 
    ch-[12px]ext-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/>
    </div>
    </div>
    {code1==''?<div className='cursor-default'>Purchase this code</div>:<>{code5Tab!=='package'?
    <div className='w-full mb-1'>
    <pre className='primary-code-container'>
    {code1.map(x1=><>{x1.name==code5Tab?<>
    {x1.valiation.map(x2=><>{x2.name=='crud multi'?<>{x2.code}</>:''}</>)}</>:''}</>)}
    </pre>
    </div>
    :<div className='w-full mb-1'>
    <pre className='primary-code-container'>
    {code1.map(x=><>{x.name==code5Tab?<>{x.code}</>:''}</>)}
    </pre>
    </div>}</>}
    </div></>:''} */}
    
    {/* <b>Financial Anlysis</b>
    <div className='flex'><div className='text-xs hover:font-bold cursor-default w-fit' onClick={()=>setDisplayDemo7(!displayDemo7)}>{displayDemo7?<TbBrowser/>:'demo'}</div>
    {userInfo!=null?<>{userInfo.unlocked_code.includes('crud multi')?<>
    {code3==''?<>'please load purchased code'</>:<div className='ml-1 text-xs mt-auto mb-auto' onClick={()=>setDisplayCode7(!displayCode7)}>{displayCode7?<MdCode/>:<MdCodeOff/>}</div>}</>:<>
    {productList.code_products.map((x)=><>{x.product_name=='crud multi'?<span className='ml-1 text-xs bg-gray-200 pl-2 pr-2 rounded-sm mb-[2px]'>crud multi series</span>:''}</>)}</>}</>:''}
    </div>
    {displayDemo7?<LlmStockNews/>:''}
    {displayCode7?<>
    <div className='w-full md:w-[500px]'>
    <div className='flex justify-between'>
    <div className='text-[8px] mt-auto'>
    {code3.map(x=><span onClick={()=>onClick2Tab2(code3, x.name, 'crud multi + modal')} className={`text-[8px] pl-1 pr-1 rounded-md hover:font-bold hover:cursor-default ${code7Tab==x.name?'font-bold':''}`}>{x.name}</span>)}
    </div>
    <div className='flex'><IoCopyOutline onClick={()=>onClick2Copy(copy7)} 
    ch-[12px]ext-xl p-1 hover:bg-gray-200 hover:rounded-md hover:cursor-default'/>
    </div>
    </div>
    {code3==''?<div className='cursor-default'>Purchase this code</div>:<>{code7Tab!=='package'?
    <div className='w-full mb-1'>
    <pre className='primary-code-container'>
    {code3.map(x1=><>{x1.name==code7Tab?<>
    {x1.valiation.map(x2=><>{x2.name=='crud multi + modal'?<>{x2.code}</>:''}</>)}</>:''}</>)}
    </pre>
    </div>
    :<div className='w-full mb-1'>
    <pre className='primary-code-container'>
    {code3.map(x=><>{x.name==code7Tab?<>{x.code}</>:''}</>)}
    </pre>
    </div>}</>}
    </div></>:''} */}    
    
        {/* <UITS/>  */}
       
        {/* <div className='mb-2'><b>Generate QR Code</b></div>
        <div className='text-xs mt-2'>payment<br/></div>
        <div className='text-xs mt-2'>url<br/></div>
        <div className='text-xs mt-2'>set 2FA<br/></div>
        <div className='mb-2'><b>OCR</b></div>
        <div className='text-xs mt-2'>2 months to take till deploy<br/></div>
        <div className='mb-2'><b>BI</b></div>
        <div className='text-xs mt-2'>2 months to take till deploy<br/></div>
        <div className='text-xs mt-2 bitter'><b>website access late</b></div>
        <div className='text-xs mt-2'>
        1 Access number<br/>
        - Total number 1D, 3M, 6M, 1Y, 3Y, 6Y, 10Y<br/>
        - Time zone of access loading> count as 1<br/>
        - Track visiting time<br/>
        https://dev.to/kalpitrathore/how-to-get-time-spent-by-users-on-a-webpage-using-node-js-530f<br/>
        <div className='text-xs mt-2 bitter'><b>button click late</b></div>
        2 Click access button<br/>
        - Total Number<br/>
        - Time zone of access<br/>
        </div>
        <div className='text-xs mt-2 bitter'><b>pie</b></div>
        <div className='text-xs mt-2 bitter'><b>graph</b></div>
        <hr className='mt-4 mb-4'/>
        <div className='mb-2'><b>API</b></div>
        <div className='text-xs mt-2 bitter'><b>rapid API yahoo finance</b></div>
        <div className='text-xs mt-2 bitter'><b>google map</b></div>
        <div className='text-xs mt-2 bitter'><b>weather</b></div>
        <br/>
        <div className='text-xs mt-2 bitter'><b>crud document</b></div> 
        <br/>
        <br/>
        <hr className='mt-4 mb-4'/>
        <div className='mb-2'><b>Review</b></div>
        <div className='text-xs mt-2 bitter'><b>Review Steps</b></div>
        <hr className='mt-4 mb-4'/>
        <div className='mb-2'><b>Reservation</b></div>
        <div className='text-xs mt-2 bitter'><b>schedule booking</b></div>
        <hr className='mt-4 mb-4'/>
        <div className='mb-2'><b>Store</b></div>
        <div className='text-xs mt-2 bitter'><b>shopping cart</b></div>
        <div className='text-xs mt-2 bitter'><b>stripe one time payment</b></div>
        <div className='text-xs mt-2 bitter'><b>stripe subscribe payment</b></div>
        
        <hr className='mt-4 mb-4'/>
        <div className='mb-2'><b>Util</b></div>
        <div className='text-xs mt-2 bitter'><b>header nav</b></div>
        <div className='text-xs mt-2 bitter'><b>bread crumb</b></div>
        <div className='text-xs mt-2 bitter'><b>side nav</b></div>
        <div className='text-xs mt-2 bitter'><b>creating pages</b></div>
        <div className='text-xs mt-2 bitter'><b>creating tab</b></div> */}

       
        
        {/* <Contact/>
        <FinanceValidation/>
       
         <Validation1/>
        
        
     <div className='mb-2'><b>Payment</b></div>
        Coming Soon
        <hr className='mt-4 mb-4'/>
        <div className='mb-2'><b>Docker</b></div>
        create yaml file<br/>
        launching frontend<br/>
        <br/>
        <br/>
        <br/>*/}
    </>
  )
}